/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { FeatureToggleGuard } from '../guards/feature-togglee-guard-service.guard'
import { RedirectGuardService } from '../guards/redirect-guard-service.guard'
import { LayoutComponent } from '../layout.component'
import { ExtRedirectToLoginAndSecurityGuard } from '../services/ext-redirect-to-login-and-sec-guard/ext-redirect-to-login-and-security.guard'
import { FeatureToggle } from '../services/feature-toggles.defintions'
import { paths } from './pages.paths'
import { SetupGuardService } from '../services/setup-guard/setup-guard.service'
import { OAuthGuardService } from '../services/oauth/oauth-guard.service'
import {
  PAYMENT_META_TITLE_KEYS,
  PERSONAL_DATA_META_TITLE_KEYS,
  SECONDARY_USER_META_TITLE_KEYS,
} from '../services/meta-fields/meta-fields.constants'
const routes: Routes = [
  {
    path: '',
    canActivate: [SetupGuardService],
    component: LayoutComponent,
    children: [
      {
        path: 'auth/callback',
        canActivate: [OAuthGuardService],
        children: [],
      },
      {
        path: ':country',
        children: [
          {
            path: ':locale',
            children: [
              {
                path: '',
                pathMatch: 'full',
                redirectTo: paths.personalData,
              },
              {
                path: paths.paymentMethods,
                data: {
                  activeMenuItem: 'MENU_ITEM_PAYMENTMETHODS',
                  featureToggle: [FeatureToggle.HIDE_PAYMENT_AND_ORDER_SLICE],
                  metaTitleKeys: PAYMENT_META_TITLE_KEYS,
                },
                canActivate: [FeatureToggleGuard],
                loadChildren: () => import('./payment-methods/payment-methods.module').then((m) => m.PaymentMethodsModule),
              },
              {
                path: paths.personalData,
                data: { activeMenuItem: 'MENU_ITEM_PERSONALDATA', metaTitleKeys: PERSONAL_DATA_META_TITLE_KEYS },
                loadChildren: () => import('./personal-data/personal-data.module').then((m) => m.PersonalDataModule),
              },
              {
                path: paths.secondaryUser,
                data: {
                  activeMenuItem: 'MENU_ITEM_SECONDARY_USER',
                  featureToggle: [FeatureToggle.HIDE_SECONDARY_USER_SLICE],
                  metaTitleKeys: SECONDARY_USER_META_TITLE_KEYS,
                },
                canActivate: [FeatureToggleGuard],
                loadChildren: () => import('./secondary-user/secondary-user.module').then((m) => m.SecondaryUserModule),
              },
              /* START ~ OLD APP REDIRECTS */
              {
                path: 'accountdata',
                canActivate: [ExtRedirectToLoginAndSecurityGuard],
                children: [],
              },
              {
                path: 'invoices/:vin',
                redirectTo: 'paymentmethods',
              },
              {
                path: 'invoices',
                redirectTo: 'paymentmethods',
              },
              {
                path: 'contactdata',
                redirectTo: 'personal-data',
              },
              {
                path: 'home',
                redirectTo: 'personal-data',
              },
              ...[
                'firstname',
                'lastname',
                'name',
                'birthday',
                'birthdate',
                'bday',
                'email',
                'e-mail',
                'phone',
                'phones',
                'number',
                'numbers',
                'telephone',
                'address',
                'addresses',
                'language',
                'preferred-language',
                'dealer',
                'country',
                'countryChange',
                'changeCountry',
                'notifications',
                'notification',
              ].map((path) => ({
                path: paths.personalData + '-' + path,
                data: {
                  activeMenuItem: 'MENU_ITEM_PERSONALDATA',
                  hash: path,
                  metaTitleKeys: PERSONAL_DATA_META_TITLE_KEYS,
                },
                loadChildren: () => import('./personal-data/personal-data.module').then((m) => m.PersonalDataModule),
              })),
              {
                path: 'paymentmethods-orders',
                data: {
                  activeMenuItem: 'MENU_ITEM_PAYMENTMETHODS',
                  hash: 'orders',
                  metaTitleKeys: PAYMENT_META_TITLE_KEYS,
                },
                loadChildren: () => import('./payment-methods/payment-methods.module').then((m) => m.PaymentMethodsModule),
              },
              /* END - OLD APP REDIRECTS */
              {
                path: '**',
                canActivate: [RedirectGuardService],
                children: [],
              },
            ],
          },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'de_DE',
          },
        ],
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'de',
      },
      {
        path: '**',
        canActivate: [RedirectGuardService],
        children: [],
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
